pageId = 'page-docs'
page = "##{ pageId }"

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.initDocViews()
  tower.initDocDnD $page

